import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { ImagesService } from 'src/modules/shared/services/images.service';
import { IClientJob } from '../../interfaces/client-job.interface';
import { sortBy, forEach, filter } from 'lodash';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';
import { IContractorDetail } from '../../interfaces/contractorDetail.interface';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-open-request-broadcast-job',
  templateUrl: './open-request-broadcast-job.component.html',
  styleUrls: ['./open-request-broadcast-job.component.scss'],
})
export class OpenRequestBroadcastJobComponent implements OnInit, OnChanges {
  staffersAndShifts = [];

  //hired staffers array will have all the hired staffers filtered out from staffer and shifts
  hiredStaffers: Array<{
    staffer: {
      _id: string,
      profileUrl: { [key: string]: string },
      address : {
          province : string
      }
    },
    distanceFromShift: any,
    state : string,
    isConfirmedShift:  boolean
  }> = [];  

  pendingConfirmationStaffers: Array<{
    staffer: {
      _id: string,
      profileUrl: { [key: string]: string },
      address : {
          province : string
      }
    },
    distanceFromShift: any,
    state : string,
    isConfirmedShift:  boolean
  }> = [];  
  //interested staffers array will have all the interested staffers filtered out from staffer and shifts
  interestedStaffers: Array<IContractorDetail>  = [];
  profileImage: string;
  @Input() view: string = "filled"
  @Input() jobItem: IClientJob;
  @Input() userData: IUser;
  @Input() previousShiftView? : boolean = false;
  @Output() hireStaffer = new EventEmitter<{
    jobItem: IClientJob,
    staffer: IUser,
    attendantStatus: string,
    showAllStaffer: boolean,
    sortBy: 'proximity' | 'rating' | 'shifts',

  }>();
  @Output() rejectStaffer = new EventEmitter<{
    jobItem: IClientJob,
    staffer: IUser,
    attendantStatus: string,
    showAllStaffer: boolean,
    sortBy: 'proximity' | 'rating' | 'shifts',

  }>();

  //////////////// sorting and functional properties /////
  sortByShift: boolean = true;
  showAllStaffer: boolean = false;
  viewingAllApplicants: boolean = false;
  totalStaffers: number = 0;
  contractorListStartIndex: number = 0;
  contractorListEndIndex: number = 2;
  applicantListStartIndex: number = 0;
  applicantListEndIndex: number = 2;
  pendingContractorListStartIndex : number = 0;
  pendingContractorListEndIndex : number = 2;
  
  constructor(
    private imagesService: ImagesService
  ) { }

  ngOnInit() {
  }
  ngOnChanges() { 
    this.showAllStaffer = this.jobItem.showAllStaffer;
    
    this.staffersAndShifts = this.jobItem.isABroadcastRequest.broadcastedTo;
    this.hiredStaffers = this.jobItem.staffersAndShifts;

    this.staffersAndShifts.forEach(item=>{
      if(typeof item.staffer !== "object"){
      let staffer = this.jobItem.isABroadcastRequest.broadcastedStaffer.find(staffer => staffer._id.toString() == item.staffer)
      item.staffer = staffer ;
      }
    })

    this.hiredStaffers.forEach(item=>{
      if(typeof item.staffer !== "object"){
      let staffer = this.jobItem.hiredStaffers.find(staffer => staffer._id.toString() == item.staffer)
      item.staffer = staffer ;
      }
    })

    if (this.jobItem.staffers && this.previousShiftView) {
      this.hiredStaffers = this.hiredStaffers.filter(stafferObj => {
        return this.jobItem.staffers.findIndex(staffer => staffer.staffer.toString() == stafferObj.staffer._id.toString()) > -1
      })
    }
    
    this.staffersAndShifts = this.staffersAndShifts.filter((attendant) => {
      return attendant.status !== 'pending' && attendant.status !== 'rejected';
    }).map(attendant => ({
      ...attendant,
      profileImage: this.imagesService.getProfilePic(attendant.staffer.profileUrl),
      isProvinceNY: attendant.staffer.address.province === 'New_York' ? true : false,
      distanceInMiles: (attendant.distanceFromShift ?? 0).toFixed(2) / 1.609,
      distanceInKm: (attendant.distanceFromShift ?? 0).toFixed(2),
      isStafferConfirmed: this.isStafferConfirmedShift(attendant.staffer._id)
    }));

    this.pendingConfirmationStaffers = this.hiredStaffers.filter((attendant) => {
      return attendant.state === 'accepted' && !attendant.isConfirmedShift && this.view !== "filled";
    }).map(attendant => ({
      ...attendant,
      profileImage: this.imagesService.getProfilePic(attendant.staffer.profileUrl),
      isProvinceNY: attendant.staffer.address.province === 'New_York' ? true : false,
      distanceInMiles: (attendant.distanceFromShift ?? 0).toFixed(2) / 1.609,
      distanceInKm: (attendant.distanceFromShift ?? 0).toFixed(2),
      isStafferConfirmed: this.isStafferConfirmedShift(attendant.staffer._id)
    }));

    this.hiredStaffers = this.hiredStaffers.filter((attendant) => {
      return (attendant.state === 'accepted' || attendant.state === 'complete') && attendant.isConfirmedShift;
    }).map(attendant => ({
      ...attendant,
      profileImage: this.imagesService.getProfilePic(attendant.staffer.profileUrl),
      isProvinceNY: attendant.staffer.address.province === 'New_York' ? true : false,
      distanceInMiles: (attendant.distanceFromShift ?? 0).toFixed(2) / 1.609,
      distanceInKm: (attendant.distanceFromShift ?? 0).toFixed(2),
      isStafferConfirmed: this.isStafferConfirmedShift(attendant.staffer._id)
    }));

    
    
    if (this.staffersAndShifts.length > 0) {
  
	  //Filter hired and interested staffers from job to handle pagination separately
     // this.hiredStaffers = filter(this.staffersAndShifts, (staffers) => { return staffers.status === 'hired'});

      this.interestedStaffers = filter(this.staffersAndShifts, (staffers) => { return staffers.status === 'interested' && !this.isContractorAppliedAfterShiftStart(staffers.staffer._id, this.jobItem.isABroadcastRequest.interestedStaffersTimeStamps || []) });

      //When initalized show at most 2 staffers if hired/interested

      if(this.hiredStaffers) {
        this.contractorListStartIndex = 0;
        this.contractorListEndIndex = 2;
      }

      if(this.interestedStaffers) {
        this.applicantListStartIndex = 0;
        this.applicantListEndIndex = 2;
      }

      if(this.pendingConfirmationStaffers) {
        this.pendingContractorListStartIndex = 0;
        this.pendingContractorListEndIndex = 2;
      }


      this.sortJobsByShift();
    }
    this.totalStaffers = this.staffersAndShifts.length;
  }


  isStafferConfirmedShift(id: string) {
    let isConfirmed = false;
    if(this.jobItem.recurringShift.isTrue) {
        if(this.jobItem.staffersAndShifts) {
          forEach(this.jobItem.staffersAndShifts, (shift) => {

            if (shift && shift.staffer && shift.staffer._id === id && shift.state === 'accepted' && shift.isConfirmedShift) {
              isConfirmed = true;
            }
          });
        }
    } else {
      if (this.jobItem.staffersAndShifts.length > 0 ) {
        forEach(this.jobItem.staffersAndShifts, (shift) => {
            if (shift && shift.staffer && shift.staffer._id === id && shift.state === 'accepted' && shift.isConfirmedShift) {
              isConfirmed = true;
            }
          });
        }
    }  

      return isConfirmed;
  }
  sortJobsByShift() {

    this.sortByShift = true;
    
    // sort isABroadcastRequest.broadcastedTo array by number of shifts completed and reverse them to get max no of shifts at top
    this.staffersAndShifts = sortBy(this.staffersAndShifts, (stafferObj) => {
      if (!this.showAllStaffer) { stafferObj.showStaffer = false; } else { stafferObj.showStaffer = true; }
      return stafferObj.staffer.shifts_completed;
    }).reverse();

    // after sorting show the first staffer a/c to the design
    this.staffersAndShifts[0].showHired = true;
  }

  hire(staffer: IUser, attendantStatus: string) {
    this.hireStaffer.emit({
      jobItem: this.jobItem,
      staffer: staffer,
      attendantStatus: attendantStatus,
      showAllStaffer: this.showAllStaffer,
      sortBy: 'shifts'
    });

  }

  reject(staffer: IUser, attendantStatus) {
    this.rejectStaffer.emit({
      jobItem: this.jobItem,
      staffer: staffer,
      attendantStatus: attendantStatus,
      showAllStaffer: this.showAllStaffer,
      sortBy: 'shifts'
    });

  }

  loadInterestedStaffers({startIndex, endIndex}) {
	//Update interested staffers list according to pagination size
  this.applicantListStartIndex = startIndex;
  this.applicantListEndIndex = endIndex;
  }

  loadHiredStaffers({startIndex, endIndex}) {
	//Update hired staffers list according to pagination size
    this.contractorListStartIndex = startIndex;
    this.contractorListEndIndex = endIndex;
   
  }

  loadPendingConfirmationStaffers({startIndex, endIndex}) {
    //Update pendingConfirmation staffers list according to pagination size
      this.pendingContractorListStartIndex = startIndex;
      this.pendingContractorListEndIndex = endIndex;
     
    }

    trackByIndex = (index: number): number => {
      return index;
    }


    // this function works for previous shift only 

    // this function filter out those who applied after shift date
    
    isContractorAppliedAfterShiftStart(
      stafferId: string,
      interestedStaffersTimeStamps: Array<{ _id: string; appliedTimeStamp: Date | string }>
    ) {
      if (!this.previousShiftView) {
        return false;
      }
      
      let hiredStaffer = this.hiredStaffers.find(staffer => staffer.staffer._id.toString() == stafferId.toString())

      if (hiredStaffer) {
        return true;
      }
    
      let isAppliedAfterShiftStart = false;
    
      // Interpret shift start as Toronto local time
      const shiftStart = moment(this.jobItem.shiftStartTime, "X").tz(this.jobItem.timeZone);
    
      const stafferTimeStampObj = interestedStaffersTimeStamps.find(
        (timeStamp) => timeStamp._id.toString() === stafferId.toString()
      );
    
      if (stafferTimeStampObj?.appliedTimeStamp) {
        // Parse applied time (ISO UTC) and convert to Toronto time
        const stafferApplied = moment(stafferTimeStampObj.appliedTimeStamp).tz(this.jobItem.timeZone);
    
        if (stafferApplied.isAfter(shiftStart)) {
          isAppliedAfterShiftStart = true;
        }
      }
    
      return isAppliedAfterShiftStart;
    }
  
}
